export default "__VITE_ASSET__78e6170c__"